import React from 'react';

// @import components
import SimpleBoxLoader from 'app_components/commons/loaderSkeletons/simpleBoxLoader';
// import HorizontalCardImageLoader from 'app_components/commons/loaderSkeletons/horizontalCardImageLoader';
// @end

const NewsItemImportantSkeleton = () => {
  return (
    <React.Fragment>
      <div className='row mb-4'>
        <div className='col-md-6 col-lg-6 mb-6'>
          <div className='mb-2'>
            <SimpleBoxLoader width='100%' height='6rem' animationSpeed={1} borderRadius='30px' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 col-lg-6 mb-6'>
          <div className='mb-2'>
            <SimpleBoxLoader width='100%' height='6rem' animationSpeed={1} borderRadius='30px' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NewsItemImportantSkeleton;
